export default [
  {
    label: "Áreas de negócio",
    to: "/settings/areas",
    icon: "fas fa-th-large",
    controller: "Area",
    action: "List"
  },
  {
    label: "Ações do controle de acesso",
    to: "/settings/access-actions",
    icon: "fas fa-bars",
    controller: "AccessAction",
    action: "List"
  },
  {
    label: "Controle de acesso",
    to: "/settings/access-controls",
    icon: "fas fa-user-lock",
    controller: "AccessControl",
    action: "List"
  },
  {
    label: "Permissões",
    to: "/settings/access-permissions",
    icon: "fas fa-key",
    controller: "UserProfileInternal",
    action: "List"
  }
];


// WEBPACK FOOTER //
// ./src/data/menu-item-internal/configuration-menu.js